<template>
  <div class="hello">
    <div id="mapContainer"></div>
  </div>
</template>
<script>
import 'echarts-gl'
// import "echarts/map/js/china.js";
import { getAction } from '../api/api'
import '../../public/map/js/china.js'
import { MapData } from '../api/url'
// import chinaPng from '../assets/china.png'
export default {
  name: 'HelloWorld',
  components: {},
  data() {
    return {
      namemap: {},
      dataArr: [],
      LinShiData: [],
      IsFirst: true,
      CityData: [],
      CountryData: [],
      ForeachData: [],
      coursel: {},
    }
  },
  props: {},
  created() {
    this.getData()
  },
  mounted() {},
  watch: {},
  methods: {
    getData() {
      let data = {
        action: 'Get_NationalMap',
      }
      getAction(MapData, data).then((res) => {
        //// console.log(res);
        this.CityData = res
        setTimeout(() => {
          this.getChart()
        }, 100)
      })
    },
    getChart() {
      this.ResetData()
    },
    Stop() {
      clearInterval(this.coursel)
    },

    ResetData() {
      let data = []

      var ProvinceData = [
        {
          name: '辽宁',
          value: ['123.429092', '41.796768'],
        },
        {
          name: '吉林',
          value: ['125.324501', '43.886841'],
        },
        {
          name: '黑龙江',
          value: ['126.642464', '45.756966'],
        },
        {
          name: '北京市',
          value: ['116.405289', '39.904987'],
        },
        {
          name: '天津',
          value: ['117.190186', '39.125595'],
        },
        {
          name: '内蒙古',
          value: ['111.751990', '40.841490'],
        },
        {
          name: '宁夏',
          value: ['106.232480', '38.486440'],
        },
        {
          name: '山西',
          value: ['112.549248', '37.857014'],
        },
        {
          name: '河北',
          value: ['114.502464', '38.045475'],
        },
        {
          name: '山东',
          value: ['117.000923', '36.675808'],
        },
        {
          name: '河南',
          value: ['113.665413', '34.757977'],
        },
        {
          name: '陕西',
          value: ['108.948021', '34.263161'],
        },
        {
          name: '湖北',
          value: ['114.298569', '30.584354'],
        },
        {
          name: '江苏',
          value: ['118.76741', '32.041546'],
        },
        {
          name: '安徽',
          value: ['117.283043', '31.861191'],
        },
        {
          name: '上海',
          value: ['121.472641', '31.231707'],
        },
        {
          name: '湖南',
          value: ['112.982277', '28.19409'],
        },
        {
          name: '江西',
          value: ['115.892151', '28.676493'],
        },
        {
          name: '浙江',
          value: ['120.15358', '30.287458'],
        },
        {
          name: '福建',
          value: ['119.306236', '26.075302'],
        },
        {
          name: '广东',
          value: ['113.28064', '23.125177'],
        },
        {
          name: '台湾',
          value: ['121.5200760', '25.0307240'],
        },
        {
          name: '海南',
          value: ['110.199890', '20.044220'],
        },
        {
          name: '广西',
          value: ['108.320007', '22.82402'],
        },
        {
          name: '重庆',
          value: ['106.504959', '29.533155'],
        },
        {
          name: '云南',
          value: ['102.71225', '25.040609'],
        },
        {
          name: '贵州',
          value: ['106.713478', '26.578342'],
        },
        {
          name: '四川',
          value: ['104.065735', '30.659462'],
        },
        {
          name: '甘肃',
          value: ['103.834170', '36.061380'],
        },
        {
          name: '青海',
          value: ['101.777820', '36.617290'],
        },
        {
          name: '西藏',
          value: ['91.11450', '29.644150'],
        },
        {
          name: '新疆',
          value: ['87.616880', '43.826630'],
        },
        {
          name: '香港',
          value: ['114.165460', '22.275340'],
        },
        {
          name: '澳门',
          value: ['113.549130', '22.198750'],
        },
      ]

      this.CityData.forEach((item) => {
        ProvinceData.forEach((items) => {
          if (item.name.indexOf(items.name) !== -1) {
            let oneCityData = {
              value: items.value,
              name: items.name,
              data: {
                jscg: item.Achievements,
                jsxq: item.Demand,
                jg: item.unit,
                yzt: item.Exhibitionhall,
              },
            }
            data.push(oneCityData)
          }
        })
      })

      let i = 0
      for (var j = 0; j < 5; j++) {
        this.ForeachData[j] = data[i]
        i++
        // ForeachData
      }
      this.initEcharts()
      this.coursel = setInterval(() => {
        setTimeout(() => {
          this.ForeachData = []
          for (var j = 0; j < 5; j++) {
            if (i === 35) {
              i = 0
            }
            this.ForeachData[j] = data[i]
            i++
            // ForeachData
          }
          this.initEcharts()
        }, 0)
      }, 5000)
    },

    initEcharts() {
      var myChart = this.$echarts.init(document.getElementById('mapContainer'))

      var option = {
        title: {
          text: '',
          left: 'center',
        },

        geo: [
          {
            map: 'china',
            // aspectScale: 0.6,
            roam: false,
            // layoutSize: "95%",
            // layoutCenter: ["50%", "50%"],
            zoom: 1,
            padding: 0,
            // left: "15%",
            top: '2%',
            label: {
              normal: {
                show: true, // 是否显示对应地名

                textStyle: {
                  color: '#333',
                },
              },
            },
            itemStyle: {
              normal: {
                borderWidth: 2, //区域边框宽度
                borderColor: '#87B6FF', //区域边框颜色
                areaColor: '#fff', //区域颜色
                shadowColor: '#87B6FF',
                shadowBlur: 5,
              },

              emphasis: {
                borderWidth: 0.5,
                borderColor: '#FF8121',
                areaColor: '#FFEEE5',
                shadowColor: '#FF8121',
                shadowBlur: 4,
              },
            },
          },
        ],

        series: [
          {
            type: 'lines',
            zlevel: 2,
            effect: {
              show: true,
              period: 4,
              trailLength: 0.02,
              symbol: 'arrow',
              symbolSize: 5,
            },
            lineStyle: {
              normal: {
                width: 1,
                opacity: 0.6,
                curveness: 0.2,
              },
            },
            tooltip: {
              trigger: 'item',
            },
            data: [],
          },
          {
            type: 'scatter',
            coordinateSystem: 'geo',
            zlevel: 5,
            label: {
              normal: {
                show: true,
                position: 'top', //显示位置
                offset: [0, 0], //偏移设置
                padding: [10, 10],
                backgroundColor: 'rgba(47, 101, 194, 0.7)',
                // image: require("../assets/bg.png"),
                borderRadius: 10,
                formatter: function (params) {
                  var name = params.name
                  var value = params.data.data

                  if (
                    value.jscg > 0 ||
                    value.jsxq > 0 ||
                    value.jg > 0 ||
                    value.yzt > 0
                  ) {
                    var text = '{fname|' + name + '}\n\n'

                    if (value.jscg > 0) {
                      text =
                        text +
                        '{flabel|技术成果：} {fvalue|' +
                        value.jscg +
                        '}\n'
                    }

                    if (value.jsxq > 0) {
                      text =
                        text +
                        '{flabel|技术需求：} {fvalue|' +
                        value.jsxq +
                        '}\n'
                    }

                    if (value.jg > 0) {
                      text =
                        text +
                        '{flabel|机       构：} {fvalue|' +
                        value.jg +
                        '}\n'
                    }

                    if (value.yzt > 0) {
                      text =
                        text + '{flabel|云展厅：} {fvalue|' + value.yzt + '}\n'
                    }

                    return text.trimRight('\n')
                  } else {
                    return ''
                  }
                },
                rich: {
                  backgroundColor: 'rgba(47, 101, 194, 0.7)',
                  fnameicon: {
                    width: 24,
                    height: 16,
                    backgroundColor: {
                      // image: require("../assets/titleicon.png"),
                    },
                  },
                  fname: {
                    color: '#23FFFC',
                    fontWeight: 500,
                    fontSize: 16,
                  },
                  flabel: {
                    color: '#ffffff',
                    fontWeight: 400,
                    fontSize: 12,
                    width: 50,
                    padding: 5,
                  },
                  fvalue: {
                    color: '#ffffff',
                    fontWeight: 'bold',
                    fontSize: 14,
                    align: 'right',
                  },
                },
              },
              emphasis: {
                show: true,
                position: 'top', //显示位置
                offset: [0, 0], //偏移设置
                padding: [10, 10],
                backgroundColor: 'rgba(16, 23, 35, .7)',
                // image: require("../assets/bg.png"),
                borderRadius: 10,
                formatter: function (params) {
                  var name = params.name
                  var value = params.data.data

                  if (
                    value.jscg > 0 ||
                    value.jsxq > 0 ||
                    value.jg > 0 ||
                    value.yzt > 0
                  ) {
                    var text = '{fname|' + name + '}\n\n'

                    if (value.jscg > 0) {
                      text =
                        text +
                        '{flabel|技术成果：} {fvalue|' +
                        value.jscg +
                        '}\n'
                    }

                    if (value.jsxq > 0) {
                      text =
                        text +
                        '{flabel|技术需求：} {fvalue|' +
                        value.jsxq +
                        '}\n'
                    }

                    if (value.jg > 0) {
                      text =
                        text +
                        '{flabel|机       构：} {fvalue|' +
                        value.jg +
                        '}\n'
                    }

                    if (value.yzt > 0) {
                      text =
                        text + '{flabel|云展厅：} {fvalue|' + value.yzt + '}\n'
                    }

                    return text.trimRight('\n')
                  } else {
                    return ''
                  }
                },
                rich: {
                  backgroundColor: 'rgba(47, 101, 194, 0.7)',
                  fnameicon: {
                    width: 24,
                    height: 16,
                    backgroundColor: {
                      // image: require("../assets/titleicon.png"),
                    },
                  },
                  fname: {
                    color: '#FF8121',
                    fontWeight: 500,
                    fontSize: 16,
                  },
                  flabel: {
                    color: '#fff',
                    fontWeight: 400,
                    fontSize: 12,
                    width: 50,
                    padding: 5,
                  },
                  fvalue: {
                    color: '#fff',
                    fontWeight: 'bold',
                    fontSize: 14,
                    align: 'right',
                  },
                },
              },
            },
            data: this.ForeachData,
          },
        ],
      }

      myChart.setOption(option)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
#mapContainer {
  height: 58.25rem;
  width: 100rem;
  margin: -30rem auto 0;
}
</style>
